import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const selectUser = (state: RootState) => state.user;

export const selectUserConnected = createSelector(
  [selectUser],
  user => user.userConnected
);